import script from "./DomainAdminList.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainAdminList.vue?vue&type=script&setup=true&lang=js"

import "./DomainAdminList.vue?vue&type=style&index=0&id=89e87736&lang=css"

const __exports__ = script;

export default __exports__